import clsx from "clsx";

type TriangleIconProps = {
  direction?: "up" | "down" | "left" | "right";
  isDark?: boolean;
  isBrand?: boolean;
  className?: string;
};

export default function TriangleIcon({
  direction = "down",
  isDark = false,
  isBrand = false,
  className,
  ...props
}: TriangleIconProps & React.HTMLAttributes<HTMLDivElement>) {
  const rotationMap = {
    up: "rotate-180",
    down: "",
    left: "rotate-90",
    right: "-rotate-90",
  };

  const textColor = isBrand
    ? "border-t-brand-primary"
    : isDark
      ? "border-t-primary-on-dark"
      : "border-t-primary";

  return (
    <div
      {...props}
      className={clsx(
        "h-0 w-0 border-t-[6px] border-r-[6px] border-l-[6px] border-r-transparent border-l-transparent",
        rotationMap[direction],
        textColor,
        className,
      )}
    />
  );
}
